import styled, { keyframes } from "styled-components";
import BotIcon from "./components/BotIcon";

const pulseRing = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(0.9);
    opacity: 0;
  }
`;

const AITab = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: 3px;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.3s ease;
`;

const IconWrapper = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  background: #10A0B617;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  /* Glow on hover */
  ${AITab}:hover & {
    background: #10A0B61d;
  }

  /* Pulse ring */
  &::before {
    content: "";
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid #10A0B61d;
    animation: ${pulseRing} 2.5s infinite;
  }
`;

const Label = styled.span`
  font-size: 14.5px;
  font-weight: bold !important;
  color: #10A0B6;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  ${AITab}:hover & {
    color: #10A0B6;
  }
`;

export default function AITabComponent({ onClick }) {
  return (
    <AITab onClick={onClick}>
      <IconWrapper>
        <BotIcon size={30} color="#10A0B6" />
      </IconWrapper>
      <Label>AI Studio</Label>
    </AITab>
  );
}
